import { TitleCasePipe } from '@angular/common';
import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { AltroSoggetto } from 'src/app/models/altro-soggetto';
import { TipoAltroSoggetto } from 'src/app/models/tipo-altro-soggetto';
import { AltroSoggettoService } from 'src/app/services/altro-soggetto.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { AltriSoggettiFormComponent } from './dialogs/form/form.component';

@Component({
  selector: 'altri-soggetti',
  templateUrl: './altri-soggetti.component.html',
  styleUrls: ['./altri-soggetti.component.scss'],
  providers: [TitleCasePipe],
})
export class AltriSoggettiComponent implements OnInit {

  headingText: string = 'Altri soggetti';


  relations: string[] = ['comune', 'comune.provincia', 'tipo'];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any = {};

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'ID',
        internalName: 'id',
        type: 'link',
        href: (model) => `/altri-soggetti/${model.id}`,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Tipo',
        internalName: 'tipo',
        displayFunction: (model) => model?.tipo?.nome,
        sortDisabled: true,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'humanIdentifier',
        sortDisabled: true,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Indirizzo',
        internalName: 'fullAddress',
        sortDisabled: true,

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Telefono',
        internalName: 'tel',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Cellulare',
        internalName: 'cell',

      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Fax',
        internalName: 'fax',

      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Email',
        internalName: 'email',

      }
    ),
  ];
  constructor(public altroSoggettoService: AltroSoggettoService,
    public dialog: MatDialog,
    private toast: ToastrService,
    private titleCase: TitleCasePipe,
    @Optional() private dialogRef: MatDialogRef<AltriSoggettiComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona un altro soggetto';
    }

    if (this.data?.defaultSearch) {
      this.search = this.data.defaultSearch;


      if (this.search?.tipo) {
        this.headingText += " " + this.search?.tipo?.nome;
        if (!this.selectionMode) {
          this.headingText = this.headingText.slice(0, -1) + 'i';
        }
      }
    }
  }

  async ngOnInit() {

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (altroSoggetto: AltroSoggetto) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare l'altro soggetto ${altroSoggetto.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.altroSoggettoService.delete(altroSoggetto);
          this.toast.success('Altro soggetto eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione altro soggetto fallita.", "Errore!");
    }
  }



  editFunction = async (altroSoggetto: AltroSoggetto) => {
    try {
      let dialogRef = this.dialog.open(AltriSoggettiFormComponent, { data: altroSoggetto });
      dialogRef.afterClosed().subscribe(async (data: AltroSoggetto) => {
        this.updateDataSource();
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica altro soggetto fallita.", "Errore!");
    }
  }


  add() {

    let addDialogRef = this.dialog.open(AltriSoggettiFormComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.updateDataSource());
  }

  tipoAltroSoggetto;

}
